import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  galleryNum: number[] = Array.from(Array(28).keys()).map(x => x + 1).reverse();

  constructor() { }

  ngOnInit() {
    console.log(this.galleryNum)
  }

}
